import React, { ReactNode } from 'react';
import './FormLinksContainer.css';

interface IFormLinksContainerProps {
    children: ReactNode;
}

export default function FormLinksContainer({
    children,
}: IFormLinksContainerProps) {
    return <div className='Pqde-FormLinksContainer'>{children}</div>;
}
